import React, { useState, useEffect } from 'react';
import CDMLogo from './CDMLogo';

function Navbar({ C, Link, useLocation, useBreakpoint, NAV_LINKS }) {
	const [scrolled, setScrolled] = useState(false);
	const [open, setOpen] = useState(false);
	const location = useLocation();
	const { isMobile, isTablet, isDesktop, px } = useBreakpoint();
	const notDesktop = !isDesktop;

	useEffect(() => {
		const fn = () => setScrolled(window.scrollY > 40);
		window.addEventListener('scroll', fn);
		return () => window.removeEventListener('scroll', fn);
	}, []);

	useEffect(() => setOpen(false), [location.pathname]);

	useEffect(() => {
		document.body.style.overflow = open ? 'hidden' : '';
		return () => {
			document.body.style.overflow = '';
		};
	}, [open]);

	return (
		<>
			<nav
				style={{
					position: 'fixed',
					top: 0,
					left: 0,
					right: 0,
					zIndex: 100,
					height: 100,
					// Scrolled: frosted dark glass. Open: solid dark (so menu doesn't show through).
					background: open
						? '#0A1210'
						: scrolled
							? 'rgba(10, 18, 16, 0.92)'
							: 'transparent',
					backdropFilter: scrolled && !open ? 'blur(16px)' : 'none',
					borderBottom:
						scrolled && !open ? '1px solid #1A2E2A' : '1px solid transparent',
					transition:
						'background 0.3s, border-color 0.3s, backdrop-filter 0.3s',
					padding: `0 ${px}`,
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
				}}
			>
				{/* Logo */}
				<Link
					to='/'
					style={{
						display: 'flex',
						alignItems: 'center',
						gap: 10,
						flexShrink: 0,
					}}
				>
					<CDMLogo size={isMobile ? 55 : 70} />
					<div>
						<div
							style={{
								fontFamily: 'DM Mono',
								fontSize: isMobile ? 14 : 16,
								fontWeight: 500,
								letterSpacing: '0.1em',
								color: C.tealLight,
								lineHeight: 1.2,
							}}
						>
							CDM
						</div>
						{!isMobile && (
							<div
								style={{
									fontFamily: 'DM Sans',
									fontSize: 12,
									color: '#4A6A66',
									letterSpacing: '0.05em',
								}}
							>
								Census Disruption Model
							</div>
						)}
					</div>
				</Link>

				{/* Desktop links */}
				{isDesktop && (
					<div style={{ display: 'flex', gap: 32, alignItems: 'center' }}>
						{NAV_LINKS?.map(({ to, label }) => (
							<Link
								key={to}
								to={to}
								className={`nav-link${location.pathname === to ? ' active' : ''}`}
							>
								{label}
							</Link>
						))}
						<Link
							to='/whitepaper'
							className='btn-primary'
							style={{ padding: '10px 20px' }}
						>
							Read Paper
						</Link>
					</div>
				)}

				{/* Hamburger */}
				{notDesktop && (
					<button
						onClick={() => setOpen((o) => !o)}
						aria-label={open ? 'Close menu' : 'Open menu'}
						style={{
							background: 'none',
							border: 'none',
							cursor: 'pointer',
							padding: 8,
							display: 'flex',
							flexDirection: 'column',
							gap: 5,
						}}
					>
						{[0, 1, 2].map((i) => (
							<span
								key={i}
								style={{
									display: 'block',
									width: 35,
									height: 4,
									borderRadius: 1,
									// White bars — visible on dark background
									background: open ? C.tealLight : '#8AACAA',
									transformOrigin: 'center',
									transition: 'transform 0.25s, opacity 0.2s, background 0.2s',
									transform: open
										? i === 0
											? 'rotate(45deg) translate(5px, 5px)'
											: i === 2
												? 'rotate(-45deg) translate(5px, -5px)'
												: 'none'
										: 'none',
									opacity: open && i === 1 ? 0 : 1,
								}}
							/>
						))}
					</button>
				)}
			</nav>

			{/* Mobile overlay */}
			{open && notDesktop && (
				<div className='mobile-overlay'>
					{NAV_LINKS.map(({ to, label }) => (
						<Link
							key={to}
							to={to}
							className={`mobile-nav-item${location.pathname === to ? ' active' : ''}`}
						>
							{label}
						</Link>
					))}
					<Link
						to='/whitepaper'
						className='btn-primary'
						style={{ marginTop: 36 }}
					>
						Read the Whitepaper
					</Link>
					<div
						style={{
							marginTop: 'auto',
							fontFamily: 'DM Mono',
							fontSize: 9,
							letterSpacing: '0.15em',
							color: '#2A4A46',
						}}
					>
						CENSUS DISRUPTION MODEL · 2025
					</div>
				</div>
			)}
		</>
	);
}

export default Navbar;
